<template>
  <div
    class="flex h-full flex-col justify-center lg:p-12"
    data-test="mobile-plan-image"
  >
    <picture
      class="flex h-60 w-60 items-center justify-center p-10 lg:h-[120px] lg:w-[120px]"
    >
      <RevIllustrationSource
        :height="80"
        :media="BreakpointQueries[Breakpoint.LG]"
        :src="image"
        :width="80"
      />

      <RevIllustration :alt="title" :height="32" :src="image" :width="32" />
    </picture>
  </div>
</template>

<script lang="ts" setup>
import {
  Breakpoint,
  BreakpointQueries,
} from '@backmarket/utils/dom/getCurrentBreakpoint'
import { RevIllustration } from '@ds/components/Illustration'
import { RevIllustrationSource } from '@ds/components/IllustrationSource'

import type { MobilePlanImageProps } from './MobilePlanImage.types'

defineProps<MobilePlanImageProps>()
</script>
